var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShieldColored(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.7898 14.9135C60.9704 14.2978 58.9991 14.2978 57.1798 14.9135L23.2998 26.3885C22.1962 26.7469 21.2216 27.4202 20.4958 28.3255C19.77 29.2307 19.3247 30.3284 19.2148 31.4835C17.5298 52.6135 20.4548 68.2385 27.3998 80.0435C34.1198 91.4685 44.8698 99.7735 59.9848 105.963C75.1148 99.7735 85.8748 91.4685 92.5948 80.0435C99.5448 68.2435 102.47 52.6135 100.785 31.4835C100.675 30.3284 100.23 29.2307 99.5037 28.3255C98.7779 27.4202 97.8033 26.7469 96.6998 26.3885L62.7898 14.9135ZM54.7748 7.81347C58.1534 6.66806 61.815 6.6663 65.1948 7.80847L99.1048 19.2835C101.596 20.113 103.789 21.6534 105.415 23.7146C107.041 25.7759 108.028 28.2679 108.255 30.8835C110.02 52.9335 107.055 70.2635 99.0598 83.8485C91.0398 97.4735 78.2548 106.838 61.3598 113.493C60.4762 113.842 59.4934 113.842 58.6098 113.493C41.7298 106.838 28.9498 97.4735 20.9348 83.8485C12.9448 70.2635 9.97976 52.9285 11.7398 30.8835C11.9664 28.2679 12.9535 25.7759 14.5794 23.7146C16.2053 21.6534 18.3989 20.113 20.8898 19.2835L54.7748 7.81347Z",
    fill: "url(#paint0_linear_1454_636)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M60 99.9994C85.16 89.7994 97.03 71.9094 94.715 38.1644C94.455 34.3294 91.835 31.0844 88.2 29.8194L64.1 21.4294C62.7817 20.9704 61.3959 20.7355 60 20.7344V99.9994Z",
    fill: "url(#paint1_linear_1454_636)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1454_636",
    x1: 59.9984,
    y1: 6.95313,
    x2: 59.9984,
    y2: 113.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#74979F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E9772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1454_636",
    x1: 77.4994,
    y1: 20.7344,
    x2: 77.4994,
    y2: 99.9994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CC416D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B7854"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldColored);
export default __webpack_public_path__ + "static/media/shield-colored.4ebe6fd207c50ed0c9ae6e5a1b157107.svg";
export { ForwardRef as ReactComponent };